/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Applyfilter1Inputs */

const de__filter_applyfilter1 = /** @type {(inputs: _Filter_Applyfilter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter anwenden`)
};

/**

* @param {_Filter_Applyfilter1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_applyfilter1 = /** @type {((inputs?: _Filter_Applyfilter1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Applyfilter1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__filter_applyfilter1(inputs)
});
export { _filter_applyfilter1 as "_filter_applyFilter" }